import Vue from 'vue';

const LISTEN_TAG = 'dn-store';

let $seg;



export default {
  namespaced: true,

  state: {
    choices: [],
  },

  getters: {
    choices: state => state.choices,
    needBeforeYearSync: (state, getters, rootState, rootGetters) => {
      return rootGetters['config/year'] === 2019;
    },
    beforeYear: (state, getters, rootState, rootGetters) => {
      return rootGetters['config/year'] -1;
    },
  },

  actions: {
    init({commit, dispatch, rootGetters}) {
      $seg = window.bcBanner.segments;

      dispatch('checkAndSync2018Data');
      commit('restore');
      dispatch('startWatch');
    },

    checkAndSync2018Data({ getters }) {
      if (!getters.needBeforeYearSync) return;

      const syncCheckKey = $seg.schoolChoices.key + '_synced';
      const isSynced = $seg.cookies.get(syncCheckKey) === '1';
      if (isSynced) return;

      $seg.schoolChoices.copyFromAnotherYear(getters.beforeYear, {
        cancelWhenHasValue: true,
        onlyCookie: true,
      });
      $seg.cookies.set(syncCheckKey, '1');
    },

    startWatch({ commit, getters }) {
      $seg.schoolChoices.listen(e => {
        commit('restore');

        if (getters.needBeforeYearSync) {
          $seg.schoolChoices.copyToAnotherYear(getters.beforeYear);
        }
      }, LISTEN_TAG);
    },

    push({commit}, choice) {
      commit('push', choice);
    },

    removeChoice({commit}, choice) {
      commit('removeChoice', choice);
    },

    clear({commit}) { commit('clear') },
  },

  mutations: {
    restore: state => {
      const choices = $seg.schoolChoices.find();
      Vue.set(state, 'choices', choices);
    },

    push: (state, choice) => {
      $seg.schoolChoices.push(choice);
    },

    removeChoice: (state, choice) => {
      $seg.schoolChoices.remove(choice);
    },

    clear: state => {
      $seg.schoolChoices.erase();
    },
  },
}



// WEBPACK FOOTER //
// ./src/js/store/modules/segments/modules/schoolChoices.js